document.addEventListener("DOMContentLoaded", () => {

    const section = document.querySelector(".reets-coming-soon");
    const countdown = document.getElementById("countdown");

    if (!section || !countdown) return;

    // ===========================
    // Countdown
    // ===========================

    const launchDate = section.dataset.launchDate;

    if (launchDate) {

        const launch = new Date(launchDate).getTime();

        function updateCountdown() {

            const now = new Date().getTime();

            const distance = launch - now;

            if (distance <= 0) {

                countdown.innerHTML = "WE ARE LIVE";

                return;

            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));

            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            countdown.innerHTML =
                `${String(days).padStart(2,"0")} : ` +
                `${String(hours).padStart(2,"0")} : ` +
                `${String(minutes).padStart(2,"0")} : ` +
                `${String(seconds).padStart(2,"0")}`;

        }

        updateCountdown();

        setInterval(updateCountdown, 1000);

    }

    // ===========================
    // Newsletter Input Focus
    // ===========================

    const input = document.querySelector(".newsletter-form input");

    if (input) {

        input.addEventListener("focus", () => {

            input.parentElement.style.borderColor = "rgba(255,255,255,.7)";

        });

        input.addEventListener("blur", () => {

            input.parentElement.style.borderColor = "";

        });

    }

    // ===========================
    // Button Hover Effect
    // ===========================

    const button = document.querySelector(".newsletter-form button");

    if (button) {

        button.addEventListener("mouseenter", () => {

            button.innerHTML = "JOIN THE CLUB ↗";

        });

    }

});